<template>
  <a
    :href="banner.buttonLink"
    class="material-banner"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
    target="_blank"
  >
    <h3
      v-if="banner.title"
      class="line-clamp-2"
      v-html="banner.title"
    />
    <h4
      v-if="banner.subtitle"
      class="line-clamp-1"
      v-html="banner.subtitle"
    />
    <p v-if="banner.buttonText">
      {{ banner.buttonText }}
    </p>
  </a>
</template>

<script>
export default {
  name: 'MaterialBannerVariant1',
  props: {
    banner: { type: Object, required: true },
  },

  data: () => ({
    isMobile: false,
  }),

  computed: {
    backgroundImage() {
      if (this.isMobile && this.banner.backgroundMobileImageUrl) {
        return this.banner.backgroundMobileImageUrl;
      }

      return this.banner.backgroundImageUrl;
    },
  },

  beforeMount() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../styles/main.scss';

.material-banner {
  aspect-ratio: 89 / 17;
  //height: 200px;
  width: 100%;
  padding: 30px 35px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  background-color: #FBBD1E;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media only screen and (max-width: 767px) {
    aspect-ratio: 1 / 1;
  }

  h3 {
    font-size: 30px;
    line-height: 35px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 5px;
  }

  h4 {
    font-size: 16px;
    line-height: 19px;
    font-weight: 500;
    color: #FF6411;
    margin-bottom: 16px;
  }

  p {
    background-color: #FF6411;
    border-radius: 4px;
    display: inline-block;
    padding: 6px 16px;
    color: #ffffff !important;
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
    margin-top: auto;
    text-decoration: none !important;
  }
}

</style>
